import { render, staticRenderFns } from "./PushList.vue?vue&type=template&id=064abcb5&scoped=true&lang=pug&"
import script from "./PushList.vue?vue&type=script&lang=js&"
export * from "./PushList.vue?vue&type=script&lang=js&"
import style0 from "./PushList.vue?vue&type=style&index=0&id=064abcb5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064abcb5",
  null
  
)

export default component.exports